/**
 * ═══════════════════════════════════════════════════════════════════════════
 * CANLI ETKİNLİK PANELİ — sözleşme (1 Eki 2026)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Ürün sahibi: *"Bir prompt atınca yanıt verene kadar çok uzun sürüyor; kişi
 * ekranda bakarken hata verdi hissine kapılabilir. Cursor'da, Devin'de,
 * Windsurf'te thinking oluyor, açılıp kapanan bir alan geliyor… Siteleri
 * fetch ediyorsa site favicon'ları geliyor."*
 *
 * Asistan cevabının ÜSTÜNDE bir panel: tur sürerken açık ("Düşünüyor…",
 * "Web'de arıyor: '…'", "Meta'da 6 kampanya okundu", favicon çipleri), bitince
 * tek satıra katlanıyor ("3 adım · 14 sn · 4 kaynak"), geçmişte de katlı.
 *
 * ---------------------------------------------------------------------------
 * 🔴 Ham araç adı YOK — önceki kararla çelişmiyor
 * ---------------------------------------------------------------------------
 * 30 Eyl 2026 kararı (sohbette ham araç adı, op kimliği, JSON parametre, iç
 * kimlik GÖSTERİLMEZ) aynen geçerli. Panel adımları OKUNUR gösteriyor: sunucu
 * her adım için bir i18n ANAHTARI + parametre üretiyor (hafıza: "sunucu
 * anahtar gönderir, ekran çevirir"), ekran çeviriyor. Anahtar bulunamazsa
 * genel cümleye düşülür — anahtar yolu da ham ad da ekrana basılmaz.
 *
 *   · çekirdek araç  → `act.<ad>` (üç hâlli cümle: running/done/failed)
 *   · ekran aracı    → `activity.step.app` + `titleKey: tool.<ad>`
 *   · katalog işlemi → `activity.step.op` + `title {tr,en}` + platform işareti
 *   · web / kod / MCP / onay / plan / düşünme → `activity.step.*`
 *
 * Adım kimliği (`s1`, `s2`…) OPAK — araç çağrı kimliği değil.
 *
 * ---------------------------------------------------------------------------
 * Kalıcı özet
 * ---------------------------------------------------------------------------
 * Turun SON asistan satırına bir `mentorivo_activity` bloğu yazılıyor
 * (`AgentActivitySummary`): adımlar, süreler, kaynak alan adları, düşünme
 * notları — kişisel veri AYIKLANMIŞ. Ham araç girdisi/sonucu, kod gövdesi ve
 * çıktısı GİRMEZ (`detail` yalnız canlı akışta). Blok modele gitmez
 * (`replayContent` süzüyor).
 *
 * Bu dosya SAF: tarayıcıda da derleniyor; istemcinin kare indirgeyicisi ve
 * satır gruplaması burada, testi API tarafında (`apps/web`te koşucu yok).
 */

/** Asistan satırının kalıcı etkinlik özeti bloğu. Modele GİTMEZ. */
export const AGENT_ACTIVITY_BLOCK_TYPE = 'mentorivo_activity';

/**
 * Asistan satırının arayüz kopyasında SUNUCU ADIMININ YERİ (web araması, sayfa
 * okuma, kod, MCP) — içeriksiz işaret. Sıralı blok modeli onu paragraf sınırı
 * sayıyor (canlı akışla aynı). Modele GİTMEZ.
 */
export const AGENT_STEP_MARK_BLOCK_TYPE = 'mentorivo_step';

/** Özetin biçim sürümü — okuyucu tanımadığı sürümü yok sayar. */
export const AGENT_ACTIVITY_VERSION = 1 as const;

export const AGENT_ACTIVITY_STEP_KINDS = [
  /** Modelin düşünmesi — `display: "updates"` notları. */
  'thinking',
  /** Çekirdek araç (`AGENT_TOOLS`, operatör, plan, yardım, bellek). */
  'tool',
  /** Mentorivo ekran aracı (`AGENT_APP_TOOLS`). */
  'app',
  /** Platform Operasyon Kataloğu işlemi. */
  'op',
  'web_search',
  'web_fetch',
  'code',
  'mcp',
  /** Onay kartı kullanıcının kararını bekliyor (ya da otomatik uygulandı). */
  'approval',
  /** `ask_user` — kullanıcının cevabını bekliyor. */
  'question',
  /** İşlem planı arka planda uygulanıyor. */
  'plan',
  /** Ekler hazırlanıyor (Files API yüklemesi). */
  'prepare',
  /** Sağlayıcı uzun sohbetin eski kısmını özetliyor. */
  'compact',
] as const;
export type AgentActivityStepKind = (typeof AGENT_ACTIVITY_STEP_KINDS)[number];

export const AGENT_ACTIVITY_STATUSES = ['running', 'ok', 'error', 'waiting', 'stopped'] as const;
export type AgentActivityStatus = (typeof AGENT_ACTIVITY_STATUSES)[number];

/**
 * Hata adımının KISA, müşteri dilinde sınıfı — `activity.error.<tür>`.
 * Araç hatasının ham metni (modele giden İngilizce cümle) ekrana gitmez.
 */
export const AGENT_ACTIVITY_ERROR_KINDS = ['not_found', 'not_allowed', 'unavailable', 'invalid', 'limit', 'generic'] as const;
export type AgentActivityErrorKind = (typeof AGENT_ACTIVITY_ERROR_KINDS)[number];

/** Etiket — `dashboard.agentChat` altında anahtar + parametre (sunucu üretir). */
export interface AgentActivityLabel {
  key: string;
  params?: Record<string, string | number>;
}

/** Canlı akışta kod adımının gövdesi — KALICI KAYDA GİRMEZ. */
export interface AgentActivityDetail {
  language: 'python' | 'bash' | 'file';
  code: string | null;
  output: string | null;
}

export interface AgentActivityStep {
  /** Opak sıra kimliği (`s1`…) — araç çağrı kimliği DEĞİL. */
  id: string;
  kind: AgentActivityStepKind;
  label: AgentActivityLabel;
  /** Katalog işleminin başlığı — ekran diline göre seçilir. */
  title?: { tr: string; en: string } | null;
  /** Ekran/çekirdek aracın başlık anahtarı (`tool.<ad>`). */
  titleKey?: string | null;
  /** Platform işareti (`AdPlatform`) — katalog işleminde. */
  platform?: string | null;
  /** Katalog işleminin nesne düzeyi (`CAMPAIGN`…) — grup cümlesi. */
  level?: string | null;
  /** Aynı anahtarlı ARDIŞIK adımlar tek satır (`groupActivityRows`). */
  group?: string | null;
  status: AgentActivityStatus;
  /** Turun başından bu yana (ms). */
  startMs: number;
  /** Süre (ms) — sürerken `null`. */
  ms: number | null;
  error?: AgentActivityErrorKind | null;
  /** Web araması sorgusu — kişisel veri ayıklanmış, kısa. */
  query?: string | null;
  /** Bulunan / okunan siteler — `www.`suz alan adı, tekrarsız. */
  sites?: string[];
  /** MCP servisinin okunur adı (bağlantının adı). */
  service?: string | null;
  /** Kodun ürettiği dosyaların adları. */
  files?: string[];
  /** Düşünme notları — kişisel veri ve iç ad ayıklanmış. */
  notes?: string | null;
  /** Onay / plan adımının kartı (`AgentProposal.proposalId`) — canlı durum için. */
  ref?: string | null;
  /** Arka plan planı: biten / toplam adım. */
  progress?: { done: number; total: number } | null;
  /** Canlı ayrıntı (kod + kısa çıktı) — kalıcı kayda GİRMEZ. */
  detail?: AgentActivityDetail | null;
}

/**
 * SSE `activity` karesi — `{ op, … }`.
 *
 *   start — tur başladı (İLK kare; sağlayıcı beklenmeden yazılıyor)
 *   step  — adımı ekle ya da güncelle (`id` ile); `notes` taşımaz, `note` ekler
 *   note  — düşünme adımına metin ekle (akış tamponlanmadan)
 *   end   — tur bitti: toplam süre ve kaynak sayısı
 */
export type AgentActivityFrame =
  | { op: 'start' }
  | { op: 'step'; step: AgentActivityStep }
  | { op: 'note'; id: string; text: string }
  | { op: 'end'; ms: number; sources: number; sites: string[]; stopped: boolean };

/** Asistan satırına yazılan özet (`mentorivo_activity` bloğunun gövdesi). */
export interface AgentActivitySummary {
  v: typeof AGENT_ACTIVITY_VERSION;
  /** Turun toplam süresi (ms). */
  ms: number;
  /** Düşünmeye geçen toplam süre (ms). */
  thinkingMs: number;
  steps: AgentActivityStep[];
  /** Cevabın kaynak alan adları (alıntılanan / okunan sayfalar). */
  sites: string[];
  /** Kaynak sayısı (aynı alan adından birden çok sayfa olabilir). */
  sources: number;
  /** Tavan aşıldıysa yazılmayan adım sayısı. */
  truncated: number;
  /** Kullanıcı durdurdu. */
  stopped: boolean;
}

export const AGENT_ACTIVITY_LIMITS = {
  /** Kalıcı özette en fazla adım (fazlası `truncated`). */
  maxSteps: 60,
  /** Bir düşünme adımının kalıcı notu (karakter). */
  maxNotesPerStep: 1_500,
  /** Turun kalıcı notlarının toplamı. */
  maxNotesTotal: 4_000,
  /** Canlı panelde bir adımın notu (karakter) — fazlası baştan kırpılır. */
  maxLiveNotes: 8_000,
  /** Adım başına site çipi. */
  maxSites: 8,
  /** Özetin kaynak alan adı listesi. */
  maxSummarySites: 12,
  maxQueryChars: 120,
  /** Kod gövdesi / çıktısı (canlı). */
  maxCodeChars: 4_000,
  maxOutputChars: 2_000,
  maxFiles: 6,
  /** Bu kadar kısa ve notsuz düşünme satır olarak çizilmez (süresi sayılır). */
  quietThinkingMs: 1_500,
  /** Bu kadar sessizlikte "Hâlâ çalışıyor" satırı. */
  silenceMs: 15_000,
} as const;

// ═══════════════════════════════════════════════════════════════════════════
// İstemci durumu + kare indirgeyicisi (SAF)
// ═══════════════════════════════════════════════════════════════════════════

export interface AgentActivityState {
  steps: AgentActivityStep[];
  /** Tur sürüyor. */
  live: boolean;
  /** İstemci saatiyle başlangıç (ms) — canlı sayaç; geçmişte `null`. */
  startedAt: number | null;
  /** Son karenin geldiği an (istemci ms) — sessizlik tespiti. */
  touchedAt: number | null;
  /** Bitince toplam süre (ms). */
  ms: number | null;
  sources: number;
  sites: string[];
  stopped: boolean;
  truncated: number;
}

/** Gönderim anında kurulan canlı durum — ilk kare beklenmeden "Düşünüyor". */
export function startActivityState(now: number): AgentActivityState {
  return { steps: [], live: true, startedAt: now, touchedAt: now, ms: null, sources: 0, sites: [], stopped: false, truncated: 0 };
}

/**
 * Bir kareyi uygular — YENİ nesne döner (React state'i karşılaştırabilsin).
 * Adım güncellemesi birleştiriyor: `notes` karede yoksa eskisi kalır,
 * `sites`/`files` birleşir, `detail` alan alan güncellenir.
 */
export function applyActivityFrame(state: AgentActivityState, frame: AgentActivityFrame, now: number): AgentActivityState {
  switch (frame.op) {
    case 'start':
      return { ...state, live: true, touchedAt: now };
    case 'step': {
      const index = state.steps.findIndex((step) => step.id === frame.step.id);
      const steps = [...state.steps];
      if (index < 0) {
        steps.push(frame.step);
      } else {
        const current = steps[index] as AgentActivityStep;
        steps[index] = mergeStep(current, frame.step);
      }
      return { ...state, steps, touchedAt: now };
    }
    case 'note': {
      if (frame.text.length === 0) return { ...state, touchedAt: now };
      const steps = state.steps.map((step) => {
        if (step.id !== frame.id) return step;
        const joined = `${step.notes ?? ''}${frame.text}`;
        const max = AGENT_ACTIVITY_LIMITS.maxLiveNotes;
        return { ...step, notes: joined.length > max ? joined.slice(joined.length - max) : joined };
      });
      return { ...state, steps, touchedAt: now };
    }
    case 'end':
      return {
        ...state,
        live: false,
        touchedAt: now,
        ms: frame.ms,
        sources: frame.sources,
        sites: frame.sites,
        stopped: frame.stopped,
        steps: state.steps.map((step) =>
          step.status === 'running' ? { ...step, status: frame.stopped ? 'stopped' : 'ok' } : step,
        ),
      };
    default:
      return state;
  }
}

/**
 * Akış bir kare göndermeden kapandıysa (eski sunucu, ağ kopması, hata) canlı
 * durumu kapatır: süren adım "durdu", sayaç donar.
 */
export function closeActivityState(state: AgentActivityState, now: number, stopped: boolean): AgentActivityState {
  if (!state.live) return state;
  return {
    ...state,
    live: false,
    stopped: state.stopped || stopped,
    ms: state.ms ?? (state.startedAt !== null ? Math.max(0, now - state.startedAt) : null),
    steps: state.steps.map((step) => (step.status === 'running' ? { ...step, status: stopped ? 'stopped' : 'ok' } : step)),
  };
}

function mergeStep(current: AgentActivityStep, next: AgentActivityStep): AgentActivityStep {
  const sites = unique([...(current.sites ?? []), ...(next.sites ?? [])]).slice(0, AGENT_ACTIVITY_LIMITS.maxSites);
  const files = unique([...(current.files ?? []), ...(next.files ?? [])]).slice(0, AGENT_ACTIVITY_LIMITS.maxFiles);
  return {
    ...current,
    ...next,
    notes: next.notes ?? current.notes ?? null,
    sites,
    files,
    detail:
      next.detail || current.detail
        ? {
            language: next.detail?.language ?? current.detail?.language ?? 'python',
            code: next.detail?.code ?? current.detail?.code ?? null,
            output: next.detail?.output ?? current.detail?.output ?? null,
          }
        : null,
  };
}

/** Kalıcı özet → katlı panel durumu. */
export function activityFromSummary(summary: AgentActivitySummary): AgentActivityState {
  return {
    steps: summary.steps,
    live: false,
    startedAt: null,
    touchedAt: null,
    ms: summary.ms,
    sources: summary.sources,
    sites: summary.sites,
    stopped: summary.stopped,
    truncated: summary.truncated,
  };
}

// ═══════════════════════════════════════════════════════════════════════════
// Satırlar — gruplama (SAF)
// ═══════════════════════════════════════════════════════════════════════════

/** Panelin bir satırı: tek adım ya da aynı türden ARDIŞIK adımların grubu. */
export interface AgentActivityRow {
  key: string;
  kind: AgentActivityStepKind;
  /** Grubun ilk adımı — etiket ondan. */
  lead: AgentActivityStep;
  steps: AgentActivityStep[];
  count: number;
  status: AgentActivityStatus;
  /** Üyelerin süre toplamı; biri sürüyorsa `null`. */
  ms: number | null;
  sites: string[];
}

/** Notsuz ve kısa düşünme — satır çizilmez, süresi sayılır. */
export function isQuietThinking(step: AgentActivityStep): boolean {
  return (
    step.kind === 'thinking' &&
    step.status !== 'running' &&
    (step.notes ?? '').trim().length === 0 &&
    (step.ms ?? 0) < AGENT_ACTIVITY_LIMITS.quietThinkingMs
  );
}

/**
 * Adımları satırlara dizer. Aynı `group` anahtarlı ARDIŞIK adımlar tek satır
 * ("Meta'da 6 kampanya okundu"); aralarındaki sessiz düşünme sırayı bozmuyor.
 * Düşünme adımları gruplanmıyor (her biri kendi notunu taşıyor).
 */
export function groupActivityRows(steps: readonly AgentActivityStep[]): AgentActivityRow[] {
  const rows: AgentActivityRow[] = [];
  for (const step of steps) {
    if (isQuietThinking(step)) continue;
    const last = rows.at(-1);
    if (last && step.group && last.lead.group === step.group && step.kind !== 'thinking') {
      last.steps.push(step);
      last.count += 1;
      last.status = combinedStatus(last.steps);
      last.ms = sumMs(last.steps);
      last.sites = unique([...last.sites, ...(step.sites ?? [])]).slice(0, AGENT_ACTIVITY_LIMITS.maxSites);
      continue;
    }
    rows.push({
      key: step.id,
      kind: step.kind,
      lead: step,
      steps: [step],
      count: 1,
      status: step.status,
      ms: step.ms,
      sites: [...(step.sites ?? [])],
    });
  }
  return rows;
}

function combinedStatus(steps: readonly AgentActivityStep[]): AgentActivityStatus {
  if (steps.some((step) => step.status === 'running')) return 'running';
  if (steps.some((step) => step.status === 'waiting')) return 'waiting';
  if (steps.some((step) => step.status === 'error')) return 'error';
  if (steps.some((step) => step.status === 'stopped')) return 'stopped';
  return 'ok';
}

function sumMs(steps: readonly AgentActivityStep[]): number | null {
  let total = 0;
  for (const step of steps) {
    if (step.ms === null) return null;
    total += step.ms;
  }
  return total;
}

/** Katlı satırın sayıları: adım (düşünme hariç), düşünme süresi. */
export function activityCounts(state: Pick<AgentActivityState, 'steps' | 'truncated'>): {
  steps: number;
  thinkingMs: number;
  done: number;
} {
  let steps = state.truncated;
  let done = 0;
  let thinkingMs = 0;
  for (const step of state.steps) {
    if (step.kind === 'thinking') {
      thinkingMs += step.ms ?? 0;
      continue;
    }
    steps += 1;
    if (step.status !== 'running') done += 1;
  }
  return { steps, thinkingMs, done };
}

/**
 * Etiket ICU'suna giden `status` biçimi — `running | done | failed | waiting |
 * stopped`. Çekirdek aracın üç hâlli cümlesi (`act.<ad>`) bekleyen/duran adımda
 * "done" biçimini kullanır.
 */
export function activityStatusForm(status: AgentActivityStatus): 'running' | 'done' | 'failed' | 'waiting' | 'stopped' {
  switch (status) {
    case 'running':
      return 'running';
    case 'error':
      return 'failed';
    case 'waiting':
      return 'waiting';
    case 'stopped':
      return 'stopped';
    default:
      return 'done';
  }
}

// ═══════════════════════════════════════════════════════════════════════════
// Savunmalı ayrıştırma — geçmiş satırı ve SSE karesi
// ═══════════════════════════════════════════════════════════════════════════

const KIND_SET: ReadonlySet<string> = new Set(AGENT_ACTIVITY_STEP_KINDS);
const STATUS_SET: ReadonlySet<string> = new Set(AGENT_ACTIVITY_STATUSES);
const ERROR_SET: ReadonlySet<string> = new Set(AGENT_ACTIVITY_ERROR_KINDS);
const KEY_PATTERN = /^[A-Za-z][\w.]{0,119}$/;

function str(value: unknown, max: number): string | null {
  if (typeof value !== 'string') return null;
  const flat = value.trim();
  if (flat.length === 0) return null;
  return flat.length > max ? `${flat.slice(0, max - 1)}…` : flat;
}

function num(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.round(value) : null;
}

function strings(value: unknown, max: number, each: number): string[] {
  if (!Array.isArray(value)) return [];
  const out: string[] = [];
  for (const item of value) {
    const text = str(item, each);
    if (text && !out.includes(text)) out.push(text);
    if (out.length >= max) break;
  }
  return out;
}

/** Tek adım — tanınmayan tür/durum/anahtar → `null` (adım düşer, panel düşmez). */
export function parseActivityStep(value: unknown): AgentActivityStep | null {
  if (!value || typeof value !== 'object') return null;
  const raw = value as Record<string, unknown>;
  const id = str(raw.id, 24);
  if (!id || typeof raw.kind !== 'string' || !KIND_SET.has(raw.kind)) return null;
  if (typeof raw.status !== 'string' || !STATUS_SET.has(raw.status)) return null;
  const label = raw.label as Record<string, unknown> | null | undefined;
  if (!label || typeof label.key !== 'string' || !KEY_PATTERN.test(label.key)) return null;
  const params: Record<string, string | number> = {};
  if (label.params && typeof label.params === 'object') {
    for (const [key, item] of Object.entries(label.params as Record<string, unknown>)) {
      if (!/^\w{1,40}$/.test(key)) continue;
      if (typeof item === 'number' && Number.isFinite(item)) params[key] = item;
      else if (typeof item === 'string') params[key] = item.slice(0, 200);
    }
  }
  const title = raw.title as Record<string, unknown> | null | undefined;
  const detail = raw.detail as Record<string, unknown> | null | undefined;
  const progress = raw.progress as Record<string, unknown> | null | undefined;
  const titleKey = str(raw.titleKey, 120);
  return {
    id,
    kind: raw.kind as AgentActivityStepKind,
    label: { key: label.key, ...(Object.keys(params).length > 0 ? { params } : {}) },
    title:
      title && typeof title.tr === 'string' && typeof title.en === 'string'
        ? { tr: title.tr.slice(0, 160), en: title.en.slice(0, 160) }
        : null,
    titleKey: titleKey && KEY_PATTERN.test(titleKey) ? titleKey : null,
    platform: str(raw.platform, 24),
    level: str(raw.level, 24),
    group: str(raw.group, 120),
    status: raw.status as AgentActivityStatus,
    startMs: num(raw.startMs) ?? 0,
    ms: num(raw.ms),
    error: typeof raw.error === 'string' && ERROR_SET.has(raw.error) ? (raw.error as AgentActivityErrorKind) : null,
    query: str(raw.query, AGENT_ACTIVITY_LIMITS.maxQueryChars),
    sites: strings(raw.sites, AGENT_ACTIVITY_LIMITS.maxSites, 253).filter(isSiteDomain),
    service: str(raw.service, 60),
    files: strings(raw.files, AGENT_ACTIVITY_LIMITS.maxFiles, 120),
    notes: typeof raw.notes === 'string' && raw.notes.length > 0 ? raw.notes.slice(0, AGENT_ACTIVITY_LIMITS.maxLiveNotes) : null,
    ref: str(raw.ref, 64),
    progress:
      progress && num(progress.done) !== null && num(progress.total) !== null
        ? { done: num(progress.done) as number, total: num(progress.total) as number }
        : null,
    detail:
      detail && (detail.language === 'python' || detail.language === 'bash' || detail.language === 'file')
        ? {
            language: detail.language,
            code: typeof detail.code === 'string' ? detail.code.slice(0, AGENT_ACTIVITY_LIMITS.maxCodeChars) : null,
            output: typeof detail.output === 'string' ? detail.output.slice(0, AGENT_ACTIVITY_LIMITS.maxOutputChars) : null,
          }
        : null,
  };
}

/** Geçmiş satırındaki özet bloğu → özet; tanınmıyorsa `null`. */
export function parseActivitySummary(value: unknown): AgentActivitySummary | null {
  if (!value || typeof value !== 'object') return null;
  const raw = value as Record<string, unknown>;
  if (raw.v !== AGENT_ACTIVITY_VERSION || !Array.isArray(raw.steps)) return null;
  const steps: AgentActivityStep[] = [];
  for (const item of raw.steps) {
    const step = parseActivityStep(item);
    if (step) steps.push({ ...step, detail: null });
    if (steps.length >= AGENT_ACTIVITY_LIMITS.maxSteps) break;
  }
  return {
    v: AGENT_ACTIVITY_VERSION,
    ms: num(raw.ms) ?? 0,
    thinkingMs: num(raw.thinkingMs) ?? 0,
    steps,
    sites: strings(raw.sites, AGENT_ACTIVITY_LIMITS.maxSummarySites, 253).filter(isSiteDomain),
    sources: num(raw.sources) ?? 0,
    truncated: num(raw.truncated) ?? 0,
    stopped: raw.stopped === true,
  };
}

/** SSE `activity` karesinin verisi → kare; tanınmıyorsa `null` (sessizce düşer). */
export function parseActivityFrame(value: unknown): AgentActivityFrame | null {
  if (!value || typeof value !== 'object') return null;
  const raw = value as Record<string, unknown>;
  switch (raw.op) {
    case 'start':
      return { op: 'start' };
    case 'step': {
      const step = parseActivityStep(raw.step);
      return step ? { op: 'step', step } : null;
    }
    case 'note':
      return typeof raw.id === 'string' && typeof raw.text === 'string'
        ? { op: 'note', id: raw.id.slice(0, 24), text: raw.text.slice(0, AGENT_ACTIVITY_LIMITS.maxLiveNotes) }
        : null;
    case 'end':
      return {
        op: 'end',
        ms: num(raw.ms) ?? 0,
        sources: num(raw.sources) ?? 0,
        sites: strings(raw.sites, AGENT_ACTIVITY_LIMITS.maxSummarySites, 253).filter(isSiteDomain),
        stopped: raw.stopped === true,
      };
    default:
      return null;
  }
}

/**
 * Favicon/alan adı çipi için geçerli ALAN ADI — küçük harf, en az bir nokta,
 * yalnız harf/rakam/tire etiketleri, IP değil. Sunucunun favicon ucu aynı
 * kuralı uyguluyor (SSRF kemerinin ÖNÜNDEKİ ilk kapı).
 */
export function isSiteDomain(value: string): boolean {
  if (value.length < 3 || value.length > 253) return false;
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/.test(value)) return false;
  /* Son etiket rakamsız (IPv4 yazımı ve sayısal TLD yok). */
  const tld = value.slice(value.lastIndexOf('.') + 1);
  return /^[a-z][a-z0-9-]*$/.test(tld) || tld.startsWith('xn--');
}

/** Adres → çipin alan adı (`www.`suz, küçük harf); geçersizse `null`. */
export function siteDomainOf(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
    const domain = parsed.hostname.replace(/^www\./i, '').toLowerCase();
    return isSiteDomain(domain) ? domain : null;
  } catch {
    return null;
  }
}

function unique(values: readonly string[]): string[] {
  return [...new Set(values)];
}
